import React, { useRef, useState } from "react";
import { useEffect } from "react";
import "../../components/newSeed/NewSeed.module.css";
import { Button } from "@material-tailwind/react";
import { QdrantObject, delete_user_data_from_client_side, get_user_data } from "../../utils/common";
import { ToastContainer } from "react-toastify";
import Editor from "../../components/newSeed/Editor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { errorToast, successToast, warnToast } from "../../utils/toastNotify";
import { ErrorMessages, ErrorType, SuccessMessages, WarnMessages } from "../../utils/constants";
import { getId, getPrivateContentDraftFileData, save_content, saveInQdrant } from "../../api/axiosApi";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import NoPage from "../NoPage";
import Draft404Page from "./Draft404Page";

function MyExclusiveDraftContent() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();
    const [title, setTitle] = useState("");
    const isSaving = useRef(false);
    const [processStatus, SetProcessStatus] = useState("")
    const [checkDraftExist, setCheckDraftExist] = useState(true);
    const saveTimeout = useRef<any>(null); // Track timeout
    let QdrantText = "";
    let newSeed: any = {
        date: "",
        title: "",
        description: "",
        id: "",
        author: ""
    };
    let QdrantTextObjectOfNewSeed: QdrantObject = {
        id: "",
        text: "",
        author: "",
        description: "",
        citation: ""
    };
    const [maxWordReached, setMaxWordReached] = useState<Boolean>(false);
    const [description, setDescription] = useState("");
    async function loadData(fileName: string) {
        try {
            const privateData = await getPrivateContentDraftFileData(fileName);

            const privateDataJson = await privateData.data;
            if(privateDataJson.status === 'error'){
                setCheckDraftExist(false);
                return;
            }
            else{
                setCheckDraftExist(true);
            }
            setDescription(privateDataJson.content.description);
            setTitle(privateDataJson.content.title);
            console.log(privateDataJson.content.status_info.status)
            privateDataJson.content.status_info !== undefined && SetProcessStatus(privateDataJson.content.status_info.status)
        } catch {


        }
    }
    useEffect(() => {
        if (get_user_data() !== null && get_user_data() !== undefined) {
            let fileName = "";
            if (location.state != null) {
                fileName = location.state.fileName;
                loadData(fileName);
            } else {
                if (id) {
                    loadData(id);
                }
            }
        } else {
            delete_user_data_from_client_side();
            navigate("/user_login");
        }
    }, [location.state, id]);
    function traverse(node: any) {
        let result = "";

        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim();
            if (text !== "") {
                result += text + "\n";
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            const children = Array.from(node.childNodes);

            for (const child of children) {
                result += traverse(child);
            }
        }

        return result;
    }

    const saveContent = async (title: string, description: string) => {
        if (isSaving.current) return; // Prevent multiple rapid clicks

        isSaving.current = true; // Mark as in-progress
        setIsLoading(true);

        let id;
        const head = "<html><body>";
        const tail = "</body></html>";

        try {
            if (location.state === null) {
                const idResponse = await getId();
                id = await idResponse.data;
                id = get_user_data().email + "-" + id.Id;
            } else {
                id = location.state.fileName;
            }
        } catch (error) {
            setIsLoading(false);
            isSaving.current = false;
            errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
            return;
        }

        if (title.trim() !== "" && description.trim() !== "" && id !== undefined) {
            newSeed = {
                id,
                title,
                author: get_user_data().name,
                date: "",
                description,
                suggestion: "",
                private: true,
                draft: true
            };

            try {
                const responseStatus = await save_content(id, newSeed);
                const resJson = await responseStatus.data;
                if (resJson.Status === "Success") {
                    successToast(SuccessMessages.ExclusiveContent.SAVED_DRAFT_MASSAGE);
                    setTimeout(() => navigate("/my-exclusive-content"), 1000);
                } else {
                    errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
                }
            } catch (error) {
                errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
                console.error("Error while saving drafts", error);
            } finally {
                setIsLoading(false);
                if (saveTimeout.current) clearTimeout(saveTimeout.current);
                saveTimeout.current = setTimeout(() => {
                    isSaving.current = false;
                }, 2000);
            }
        } else {
            setIsLoading(false);
            isSaving.current = false;
            warnToast(WarnMessages.ExclusiveContent.REQUIRED_FIELD);
        }
    };

    const isFinalizing = useRef(false);
    const finalizeTimeout = useRef<any>(null);
    const finalizeContent = async (title: string, description: string) => {
        if (isFinalizing.current) return; // Prevent multiple rapid clicks

        isFinalizing.current = true; // Mark as in-progress
        setIsLoading(true);
        let id: any;
        const head = "<html><body>";
        const tail = "</body></html>";
        try {
            if (location.state === null) {
                const idResponse = await getId();
                id = await idResponse.data;
                id = get_user_data().email + "-" + id.Id;
            } else {
                id = location.state.fileName;
            }
        } catch (error) {
            console.error("Failed to fetch ID", error);
            setIsLoading(false);
            isFinalizing.current = false;
            errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
            return;
        }

        if (title.trim() !== "" && description.trim() !== "" && id !== undefined) {
            let descriptionPlainText = "";
            if (title.trim() !== "" && description.trim() !== "") {
                const parser = new DOMParser();
                const doc = parser.parseFromString(head + description + tail, "text/html");
                descriptionPlainText = traverse(doc.body).trim();
                // QdrantText += "Title: " + title + " Description: " + textContent;
            }
            newSeed = {
                id: id + "",
                title: title,
                author: get_user_data().name,
                date: "",
                description: description,
                suggestion: "",
                private: true,
                draft: true,
                parsed_description_text: descriptionPlainText,
                citation: id + ".txt"
            };

            try {
                const responseStatus = await saveInQdrant(newSeed);
                const resJson = await responseStatus.data;
                if (resJson.status === "pending") {
                    successToast(resJson.message);
                    setTimeout(() => {
                        if (id) navigate(`/my-exclusive-content`);
                    }, 2000);
                } else {
                    if (resJson.error === "TOKEN_LIMIT_EXCEEDED") errorToast(ErrorMessages.ExclusiveContent.TOKEN_LIMIT_EXCEEDED);
                    else errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
                }
            } catch (error:any) {
                // 
                console.error("Error finalizing content", error.response.data.error);
                if(error.response.data.error === 'upload_failed'){
                    errorToast(error.response.data.message)
                }
                else{
                    errorToast(ErrorMessages[ErrorType.INTERNAL_SERVER_ERROR]);
                }
            } finally {
                setIsLoading(false);
                // Use timeout to add delay before allowing the next finalize action
                if (finalizeTimeout.current) clearTimeout(finalizeTimeout.current);
                finalizeTimeout.current = setTimeout(() => {
                    isFinalizing.current = false; // Reset flag after a delay
                }, 2000); // 2-second delay before allowing next finalize
            }
        } else {
            warnToast(WarnMessages.ExclusiveContent.REQUIRED_FIELD);
            isFinalizing.current = false;
            setIsLoading(false);
        }
    };
    const getInitials = (name: string) => {
        return name
            .split(" ")
            .map(n => n[0])
            .join("");
    };
    if(!checkDraftExist){
        return <Draft404Page></Draft404Page>
    }
    return (
        <>
            <div className="h-full">
                <form className="flex h-full flex-col gap-2 p-4 w-full">
                    <div className="min-w-96">
                        <label className="font-title">Title</label>
                        <textarea
                            name=""
                            id=""
                            style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                            value={title}
                            onChange={e => setTitle(e.target.value)}
                            className="shadow-lg w-full h-[7vh] resize-none px-4 focus:border-transparent outline-none"
                        ></textarea>
                    </div>
                    <label className="font-title">Description</label>
                    <div className="h-full">
                        <Editor description={description} setDescription={setDescription} className="overflow-auto" />
                        <div className="text-red-500">{maxWordReached ? WarnMessages.ExclusiveContent.REACHED_MAX_WORD : ""}</div>
                        <div className=" pt-10 flex items-center justify-center space-x-4 w-full">
                            <Button
                                className={`min-w-36 h-10 font-bold bg-blue-400 ${processStatus === 'pending' || processStatus=== 'success' ? "bg-slate-400" : "bg-blue-400	" } text-white`}
                                onClick={() => saveContent(title, description)}
                                disabled={isSaving.current || isFinalizing.current || processStatus=== 'pending' || processStatus=== 'success'}
                            >
                                Save as Draft
                            </Button>

                            <Button
                                className={`min-w-36 h-10 font-bold ${processStatus === 'pending' || processStatus=== 'success' ? "bg-slate-400" : "bg-blue-400	" } text-white`}
                                onClick={() => {
                                    finalizeContent(title, description);
                                }}
                                disabled={isSaving.current || processStatus === 'pending' || processStatus=== 'success'}
                                // title={processStatus=== 'pending' ? "Publishing":"fdh"}
                            >
                                Publish
                            </Button>
                        </div>
                        {isLoading && (
                            <div className="fixed inset-0 flex justify-center  bg-black bg-opacity-15 items-center  z-50">
                                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-green-900 border-opacity-90"></div>
                            </div>
                        )}
                    </div>
                </form>
            </div>
            <ToastContainer toastStyle={{ marginTop: "8vh" }} />
        </>
    );
}

export default MyExclusiveDraftContent;
